import React from 'react';
import PropTypes from 'prop-types';
import { Success } from '../../../Elements';
import { Button } from 'semantic-ui-react';
import currencyFormatter from 'currency-formatter';

const RefundConfirmation = ({ refund, onClose, originalPayment }) => {
  // eslint-disable-next-line no-underscore-dangle
  const isCreditCard = originalPayment.__typename === 'SquarePayment';
  return (
    <div style={{ textAlign: 'center' }}>
      <Success />
      <h3>Refund {isCreditCard ? 'Issued' : 'Recorded'}</h3>
      <p style={{ marginBottom: '2em' }}>
        A refund of {currencyFormatter.format(refund.amount_cents / 100, {
          code: originalPayment.amount_currency
        })} has been {isCreditCard ? 'issued' : 'recorded'}.
      </p>
      <Button basic fluid content='Done' onClick={onClose} />
    </div>
  );
};

RefundConfirmation.propTypes = {
  refund: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  originalPayment: PropTypes.object.isRequired
};

export default RefundConfirmation;



// WEBPACK FOOTER //
// ./webpack/components/Document/Invoice/Refund/Confirmation.js